import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useSettings } from "../lib/SettingsContext";

const FALLBACK = [
  ["Cum este garantată autenticitatea pieselor?", "Fiecare piesă din colecția noastră este însoțită de un certificat de autenticitate."],
];

export default function FAQ() {
  const { settings } = useSettings();
  const items = (settings.faq && settings.faq.length > 0) ? settings.faq.map(f => [f.q, f.a]) : FALLBACK;
  const [open, setOpen] = useState(0);
  return (
    <main className="pt-32 pb-20 max-w-3xl mx-auto px-6" data-testid="faq-page">
      <header className="text-center mb-16">
        <p className="label-luxe text-[#D4AF37] mb-3">Asistență</p>
        <h1 className="h-display text-5xl text-[#F8F4E6]">Întrebări Frecvente</h1>
      </header>
      <ul className="divide-y divide-[#D4AF37]/15">
        {items.map(([q, a], i) => (
          <li key={i} data-testid={`faq-${i}`}>
            <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full py-6 flex justify-between items-center text-left">
              <span className="font-serif text-xl text-[#F8F4E6]">{q}</span>
              <ChevronDown size={18} className={`text-[#D4AF37] transition-transform ${open === i ? "rotate-180" : ""}`} />
            </button>
            {open === i && <p className="text-[#A39E8A] pb-6 leading-relaxed">{a}</p>}
          </li>
        ))}
      </ul>
    </main>
  );
}
